{
    "CustomisePopupTitle": "Personalizar função de administrador",
    "FooterActionsSubmit": "Enviar",
    "FooterActionsCancel": "Cancelar",
    "FooterActionsHelp": "Ajuda?",
    "TableHeadingAdminAccess": "Acesso de administração",
    "HeadingAdministrate": "Administrar",
    "HeadingView": "Visualizar",
    "HeadingAdd": "Adicionar",
    "HeadingModify": "alterar",
    "HeadingDelete": "remover",
    "EntryCme": "Gestão CME",
    "EntryDevices": "Dispositivos",
    "EntryDevicesSub": "(Extensões \/ Grupos \/ Outros Dispositivos)",
    "EntryAgents": "Agentes",
    "EntryDirectory": "Diretórios",
    "EntryApplicationUsers": "Utilizadores da aplicação",
    "EntryCodes": "Códigos",
    "EntryTelServers": "Servidores de telefonia",
    "EntryPartition": "Partições",
    "EntryOmnichannel": "Omnicanal",
    "EntryRecordings": "Gravação",
    "EntryMessages": "Mensagens",
    "EntryDatabase": "Base de dados",
    "TableHeadingStatusTools": "Estado e acesso a ferramentas",
    "HeadingSection": "Secção",
    "EntryLicences": "Licenças",
    "EntryLogging": "Exploração madeireira",
    "EntryLogManagement": "gestão de logs",
    "EntryAuditTrail": "Trilha de auditoria",
    "EntryTelephoneModuleStatus": "Estado do Módulo de Telefonia",
    "EntryOmnichannelStatus": "Estado do Omnicanal",
    "EntryCallControl": "controlo de chamadas",
    "EntryServerStatus": "Estado do servidor",
    "TableHeadingActions": "Ações",
    "HeadingAction": "Açao",
    "HeadingAllowed": "Permitido",
    "EntryCopyReportsTo": "Copiar relatórios para...",
    "EntrySignInAs": "Entrar como...",
    "EntryBillingFilesDownload": "CDRs de faturação",
    "EntryBillingSummary": "Resumo da faturação",
    "EntryChangeLicenceLevel": "Alterar nível de licença",
    "SyncPartition": "Sincronizar partição",
    "ViewChangedWarning": "Sem a opção Visualizar, {} só pode ser {} usando a API.",
    "Update": "Atualizada",
    "Delete": "deletado",
    "ViewChangeOr": "ou",
    "CustomiseRole_Add": "adicionado",
    "NAME": "CustomiseRole",
    "EntryUserRole": "Funções de utilizador",
    "EntryChangeTelephonyServerBillingStatus": "Alterar o estado de faturação do servidor de telefonia",
    "EptAccess": "Ferramenta de Aprovisionamento Fácil",
    "EntryLogFilesDownload": "Descarregar ficheiros de registo",
    "TelSysSyncRestrictions": "Alterar parâmetros de sincronização máxima",
    "CMEBrandingConfig": "Configuração da Marca CME",
    "EntryCrm": "Gestão de CRM",
    "EntryClientConfig": "Configuração do cliente",
    "EditOwningCMEDomainProfile": "Editar perfil de domínio CME",
    "EditOwningCMEBranding": "Editar a Marca do CME",
    "EditOwningCMEProvisioning": "Editar o Aprovisionamento CME (Sincronização do Pacote de Serviços)",
    "EditOwnCMEDomainProfile": "Editar perfil de domínio do próprio CME",
    "EditOwnCMEBranding": "Editar a Marca do próprio CME",
    "EditOwnCMEProvisioning": "Editar o Aprovisionamento do próprio CME",
    "Policy": "Política"
}